import { Component, OnInit, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { NoticiaDetalhesPage } from '../noticia-detalhes/noticia-detalhes.page';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { ImagePipe } from 'src/app/pipes/image/image';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-list-imagem',
  templateUrl: './list-imagem.component.html',
  styleUrls: ['list-imagem.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    ImagePipe,
    CommonModule
  ]
})
export class ListImagemComponent implements OnInit {
  @Input()
  config: any;

  constructor(public modalCtrl: ModalController) { }

  ngOnInit() { }

  getMes() {
    return format(parseISO(this.config.date), "MMM", { locale: ptBR });
  }

  getDia() {
    return format(parseISO(this.config.date), "dd", { locale: ptBR });
  }

  async abrirNoticia() {
    const modalPage = await this.modalCtrl.create({
      component: NoticiaDetalhesPage,
      componentProps: { 'id': this.config.id }
    });
    modalPage.present();
  }

}
